export default "__VITE_ASSET__XaI6R_0Z__"